<template>
  <div v-if="TotalModel!=null" class>
    <!-- header start -->
    <van-nav-bar
      title="佣金明细"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="commission-filter">
      <span class="t15 c6">收支概览</span>
      <div class="filter-btn" @click="clickDateFilter">
        <div class="van-dropdown-menu__title">
          <div class="van-ellipsis">筛选</div>
        </div>
      </div>
      <div class style="position:relative">
        <div class="filter-btn" @click="catePopupShow = true">
          <div class="van-dropdown-menu__title">
            <div class="van-ellipsis">分类</div>
          </div>
        </div>
        <div id="modal-div" v-if="catePopupShow">
          <div class="nav-ul">
            <div class="menu_ul">
              <div class="menu_li" v-for="(item,index) in tabs" :key="index">
                <div
                  @click="changeType(index)"
                  class="a"
                  :class="{active : index == selectIndex}"
                >{{item}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-overlay :z-index="1000" :show="catePopupShow" @click="catePopupShow = false"></van-overlay>
    <!-- <van-calendar v-model="calendarShow" :min-date="minDate" :max-date="maxDate" :round="false" position="right" type="range" color="#24a378" @confirm="onConfirm" /> -->

    <div class="commission-nav">
      <div class="item">
        <div class="tit">推荐会员收入(元)</div>
        <div class="num">{{TotalModel.TotalDistributionCommission.TotalCommission}}</div>
      </div>
      <div v-if="levelTid==2" class="line"></div>
      <div v-if="levelTid==2" class="item">
        <div class="tit">会员二次消费收入(元)</div>
        <div class="num">{{TotalModel.TotalDistributionCommission.TotalRechargeCommission}}</div>
      </div>
    </div>

    <van-tabs
      sticky
      offset-top="46"
      title-active-color="#333"
      title-inactive-color="#888"
      background="#f8f8f8"
      color="#c3c3c3"
      :border="false"
      line-height="2"
    >
      <van-tab title="推荐会员收支明细">
        <!-- <div class="commission-list" v-for="item in 5" :key="item">
          <div class="hd">
            <div class="left-cnt">
              <div class="btn">分享订单</div>
              <div class="date">03-10 14:09</div>
            </div>
            <div class="status">交易成功</div>
          </div>
          <div class="bd">
            <div class="card-info">
              <div class="card-hd">
                <img src="@/assets/images/me/vip-gaoji.png" alt class="avatar" />
              </div>
              <div class="card-bd">
                <div class="info-item">
                  <span class="label">会员类型：</span>
                  <span class="text">高级会员</span>
                </div>
                <div class="info-item">
                  <span class="label">付款金额：</span>
                  <span class="text">￥ 399</span>
                </div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div class="member-info">
              <span class="tit">客户 |</span>
              <span class="name">engineer888999</span>
              <span>一级会员</span>
            </div>
            <div class="income">
              <span>预估收益</span>
              <span class="money">￥100</span>
            </div>
          </div>
        </div>-->
        <commission_list ref="commissionlist"></commission_list>
      </van-tab>
      <van-tab v-if="levelTid==2" title="会员二次消费收支明细">
        <commission_recharge_list></commission_recharge_list>
        <!-- <div class="commission-list" v-for="item in 3" :key="item">
          <div class="hd">
            <div class="left-cnt">
              <div class="btn">二次充值</div>
              <div class="date">03-10 14:09</div>
            </div>
            <div class="status">交易成功</div>
          </div>
          <div class="bd">
            <p>网上充值100元，获得10000个天堂币</p>
            <p>付款金额￥99</p>
          </div>
          <div class="ft">
            <div class="member-info">
              <span class="tit">客户 |</span>
              <span class="name">engineer888999</span>
              <span>一级会员</span>
            </div>
            <div class="income">
              <span>预估收益</span>
              <span class="money">￥100</span>
            </div>
          </div>
        </div>-->
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
//import { Calendar } from "vant";
import { mapGetters, mapState } from "vuex";
import commission_list from "@/components/commission_list";
import commission_recharge_list from "@/components/commission_recharge_list";
export default {
  data() {
    return {
      tabs: [],
      catePopupShow: false,
      calendarShow: false,
      minDate: new Date(2009, 0, 1),
      maxDate: new Date(),
      selectIndex: 0,
      TotalModel: null,
      isFirstEnter: false,
      queryData: null,
      levelTid:0
    };
  },
  components: {
    //[Calendar.name]:Calendar,
    commission_list,
    commission_recharge_list
  },
  computed: {
    ...mapState({
      queryInput: state => state.transactionDetail.queryInput
    })
  },
  mounted() {
    var _query=this.$route.query;
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    this.levelTid=_query.levelTid;

  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      var that = this;
      that.$store
        .dispatch({
          type: "GetDistributionCommissionIndex"
        })
        .then(
          res => {
            that.TotalModel = res;
            that.tabs = [];
            res.LevelList.forEach(element => {
              that.tabs.push(element.LevelName);
            });
          },
          error => {}
        );
    },
    onClickLeft() {
      this.$router.go(-1);
    },

    // onConfirm(date) {
    //   const [start, end] = date;
    //   this.show = false;
    //   this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    // },
    clickDateFilter() {
      this.$router.push("/DateFilter");
    },
    changeType(index) {
      this.selectIndex = index;
      this.catePopupShow = false;
      var _filterModel = this.TotalModel.LevelList[this.selectIndex];
      //console.log(_filterModel.LevelId);
      Object.assign(this.$refs.commissionlist.options, {
        LevelId: _filterModel.LevelId,
        pageIndex: 1
      });
      this.$refs.commissionlist.getList();
    },
    changeTime() {
      var _queryInput = JSON.parse(this.queryInput);
      console.log(_queryInput);
      if (_queryInput.startTime !=""&& _queryInput.endTime !="") {
        Object.assign(this.$refs.commissionlist.options, {
          TimeType:"",
          CustomTime: _queryInput.startTime + "&" + _queryInput.endTime,
          pageIndex: 1
        });
      } else {
        Object.assign(this.$refs.commissionlist.options, {
          TimeType: _queryInput.timeType,
          CustomTime:"",
          pageIndex: 1
        });
      }
      this.$refs.commissionlist.getList();
    },
    search(data) {
      console.log(data);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "DateFilter") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    console.log(this.queryInput);
    if (this.queryInput != this.queryData) {
      console.log("change");
      this.queryData = this.queryInput;
      this.changeTime();
    }

    if (!this.$route.meta.isBack || this.isFirstEnter) {
      this.init();
    }
    this.$route.meta.isBack = false;
    this.isFirstEnter = false;
  },
  created() {
    this.isFirstEnter = true;
    this.$store.commit({
        type:"setOrderDateFilter",
        input:null
      })
}
};
</script>

<style scoped>
</style>
